import { StyledAdminFilterSelectContainer, StyledAdminFilterSelectDropdown } from './styles';

interface IAdminSelectProps {
  children?: React.ReactNode;
  filterName: string;
  optionsList: string[];
  onSelect: (value: string) => void;
}

export const AdminFilterSelect = ({ filterName, optionsList, onSelect }: IAdminSelectProps) => {
  const selectOptionHandler = (option: string) => () => {
    onSelect(option);
  };

  return (
    <StyledAdminFilterSelectContainer>
      <StyledAdminFilterSelectDropdown>
        {optionsList.map((option) => (
          <div
            key={option}
            className="admin-select-dropdown-element"
            onClick={selectOptionHandler(option)}
          >
            {option}
          </div>
        ))}
      </StyledAdminFilterSelectDropdown>
    </StyledAdminFilterSelectContainer>
  );
};
